import assetCZSI2 from './ay-anniversary-full/CZ-SI.svg';
import assetGRCY2 from './ay-anniversary-full/GR-CY.svg';
import assetBgBG2 from './ay-anniversary-full/bg_BG.svg';
import assetDaDK2 from './ay-anniversary-full/da_DK.svg';
import assetDeDE2 from './ay-anniversary-full/de_DE.svg';
import assetEnZZ2 from './ay-anniversary-full/en_ZZ.svg';
import assetEsES2 from './ay-anniversary-full/es_ES.svg';
import assetEsZZ2 from './ay-anniversary-full/es_ZZ.svg';
import assetEtEE2 from './ay-anniversary-full/et_EE.svg';
import assetFiFI2 from './ay-anniversary-full/fi_FI.svg';
import assetFrBECHLU2 from './ay-anniversary-full/fr_BE-CH-LU.svg';
import assetFrFR2 from './ay-anniversary-full/fr_FR.svg';
import assetHrHR2 from './ay-anniversary-full/hr_HR.svg';
import assetHuHU2 from './ay-anniversary-full/hu_HU.svg';
import assetItCH2 from './ay-anniversary-full/it_CH.svg';
import assetItIT2 from './ay-anniversary-full/it_IT.svg';
import assetLtLT2 from './ay-anniversary-full/lt_LT.svg';
import assetLvLV2 from './ay-anniversary-full/lv_LV.svg';
import assetNlBENL2 from './ay-anniversary-full/nl_BE-NL.svg';
import assetNoNO2 from './ay-anniversary-full/no_NO.svg';
import assetPlPL2 from './ay-anniversary-full/pl_PL.svg';
import assetPtPT2 from './ay-anniversary-full/pt_PT.svg';
import assetRoRO2 from './ay-anniversary-full/ro_RO.svg';
import assetRuLVEE2 from './ay-anniversary-full/ru_LV-EE.svg';
import assetSkSK2 from './ay-anniversary-full/sk_SK.svg';
import assetSvSE2 from './ay-anniversary-full/sv_SE.svg';
import assetCZSI from './ay-anniversary/CZ-SI.svg';
import assetGRCY from './ay-anniversary/GR-CY.svg';
import assetBgBG from './ay-anniversary/bg_BG.svg';
import assetDaDK from './ay-anniversary/da_DK.svg';
import assetDeDE from './ay-anniversary/de_DE.svg';
import assetEnZZ from './ay-anniversary/en_ZZ.svg';
import assetEsES from './ay-anniversary/es_ES.svg';
import assetEsZZ from './ay-anniversary/es_ZZ.svg';
import assetEtEE from './ay-anniversary/et_EE.svg';
import assetFiFI from './ay-anniversary/fi_FI.svg';
import assetFrBECHLU from './ay-anniversary/fr_BE-CH-LU.svg';
import assetFrFR from './ay-anniversary/fr_FR.svg';
import assetHrHR from './ay-anniversary/hr_HR.svg';
import assetHuHU from './ay-anniversary/hu_HU.svg';
import assetItCH from './ay-anniversary/it_CH.svg';
import assetItIT from './ay-anniversary/it_IT.svg';
import assetLtLT from './ay-anniversary/lt_LT.svg';
import assetLvLV from './ay-anniversary/lv_LV.svg';
import assetNlBENL from './ay-anniversary/nl_BE-NL.svg';
import assetNoNO from './ay-anniversary/no_NO.svg';
import assetPlPL from './ay-anniversary/pl_PL.svg';
import assetPtPT from './ay-anniversary/pt_PT.svg';
import assetRoRO from './ay-anniversary/ro_RO.svg';
import assetRuLVEE from './ay-anniversary/ru_LV-EE.svg';
import assetSkSK from './ay-anniversary/sk_SK.svg';
import assetSvSE from './ay-anniversary/sv_SE.svg';
import assetAyCampaignLogoIt from './ay-campaign-logo-it.svg';
import assetAyCampaignLogoLt from './ay-campaign-logo-lt.svg';
import assetAyCampaignLogoLv from './ay-campaign-logo-lv.svg';
import assetAyCampaignLogoPl from './ay-campaign-logo-pl.svg';
import assetAyCampaignLogo from './ay-campaign-logo.svg';
import assetLogoDefault from './logo-default.svg';
export enum LogoIconName {
  AboutYouLogo,
  AY10_bg_BG,
  AY10_CZ_SI,
  AY10_da_DK,
  AY10_de_DE,
  AY10_en_ZZ,
  AY10_es_ES,
  AY10_es_ZZ,
  AY10_et_EE,
  AY10_fi_FI,
  AY10_fr_BE_CH_LU,
  AY10_fr_FR,
  AY10_GR_CY,
  AY10_hr_HR,
  AY10_hu_HU,
  AY10_it_CH,
  AY10_it_IT,
  AY10_lt_LT,
  AY10_LV_EE,
  AY10_lv_LV,
  AY10_nl_BE_NL,
  AY10_no_NO,
  AY10_pl_PL,
  AY10_pt_PT,
  AY10_ro_RO,
  AY10_sk_SK,
  AY10_sv_SE,
  AY10F_bg_BG,
  AY10F_CZ_SI,
  AY10F_da_DK,
  AY10F_de_DE,
  AY10F_en_ZZ,
  AY10F_es_ES,
  AY10F_es_ZZ,
  AY10F_et_EE,
  AY10F_fi_FI,
  AY10F_fr_BE_CH_LU,
  AY10F_fr_FR,
  AY10F_GR_CY,
  AY10F_hr_HR,
  AY10F_hu_HU,
  AY10F_it_CH,
  AY10F_it_IT,
  AY10F_lt_LT,
  AY10F_LV_EE,
  AY10F_lv_LV,
  AY10F_nl_BE_NL,
  AY10F_no_NO,
  AY10F_pl_PL,
  AY10F_pt_PT,
  AY10F_ro_RO,
  AY10F_sk_SK,
  AY10F_sv_SE,
  CampaignLogo,
  CampaignLogoIT,
  CampaignLogoLT,
  CampaignLogoLV,
  CampaignLogoPL,
}

export const logoIconAssets: {
  [key in LogoIconName]: string;
} = {
  [LogoIconName.AboutYouLogo]: assetLogoDefault,
  [LogoIconName.AY10_bg_BG]: assetBgBG,
  [LogoIconName.AY10_CZ_SI]: assetCZSI,
  [LogoIconName.AY10_da_DK]: assetDaDK,
  [LogoIconName.AY10_de_DE]: assetDeDE,
  [LogoIconName.AY10_en_ZZ]: assetEnZZ,
  [LogoIconName.AY10_es_ES]: assetEsES,
  [LogoIconName.AY10_es_ZZ]: assetEsZZ,
  [LogoIconName.AY10_et_EE]: assetEtEE,
  [LogoIconName.AY10_fi_FI]: assetFiFI,
  [LogoIconName.AY10_fr_BE_CH_LU]: assetFrBECHLU,
  [LogoIconName.AY10_fr_FR]: assetFrFR,
  [LogoIconName.AY10_GR_CY]: assetGRCY,
  [LogoIconName.AY10_hr_HR]: assetHrHR,
  [LogoIconName.AY10_hu_HU]: assetHuHU,
  [LogoIconName.AY10_it_CH]: assetItCH,
  [LogoIconName.AY10_it_IT]: assetItIT,
  [LogoIconName.AY10_lt_LT]: assetLtLT,
  [LogoIconName.AY10_LV_EE]: assetRuLVEE,
  [LogoIconName.AY10_lv_LV]: assetLvLV,
  [LogoIconName.AY10_nl_BE_NL]: assetNlBENL,
  [LogoIconName.AY10_no_NO]: assetNoNO,
  [LogoIconName.AY10_pl_PL]: assetPlPL,
  [LogoIconName.AY10_pt_PT]: assetPtPT,
  [LogoIconName.AY10_ro_RO]: assetRoRO,
  [LogoIconName.AY10_sk_SK]: assetSkSK,
  [LogoIconName.AY10_sv_SE]: assetSvSE,
  [LogoIconName.AY10F_bg_BG]: assetBgBG2,
  [LogoIconName.AY10F_CZ_SI]: assetCZSI2,
  [LogoIconName.AY10F_da_DK]: assetDaDK2,
  [LogoIconName.AY10F_de_DE]: assetDeDE2,
  [LogoIconName.AY10F_en_ZZ]: assetEnZZ2,
  [LogoIconName.AY10F_es_ES]: assetEsES2,
  [LogoIconName.AY10F_es_ZZ]: assetEsZZ2,
  [LogoIconName.AY10F_et_EE]: assetEtEE2,
  [LogoIconName.AY10F_fi_FI]: assetFiFI2,
  [LogoIconName.AY10F_fr_BE_CH_LU]: assetFrBECHLU2,
  [LogoIconName.AY10F_fr_FR]: assetFrFR2,
  [LogoIconName.AY10F_GR_CY]: assetGRCY2,
  [LogoIconName.AY10F_hr_HR]: assetHrHR2,
  [LogoIconName.AY10F_hu_HU]: assetHuHU2,
  [LogoIconName.AY10F_it_CH]: assetItCH2,
  [LogoIconName.AY10F_it_IT]: assetItIT2,
  [LogoIconName.AY10F_lt_LT]: assetLtLT2,
  [LogoIconName.AY10F_LV_EE]: assetRuLVEE2,
  [LogoIconName.AY10F_lv_LV]: assetLvLV2,
  [LogoIconName.AY10F_nl_BE_NL]: assetNlBENL2,
  [LogoIconName.AY10F_no_NO]: assetNoNO2,
  [LogoIconName.AY10F_pl_PL]: assetPlPL2,
  [LogoIconName.AY10F_pt_PT]: assetPtPT2,
  [LogoIconName.AY10F_ro_RO]: assetRoRO2,
  [LogoIconName.AY10F_sk_SK]: assetSkSK2,
  [LogoIconName.AY10F_sv_SE]: assetSvSE2,
  [LogoIconName.CampaignLogo]: assetAyCampaignLogo,
  [LogoIconName.CampaignLogoIT]: assetAyCampaignLogoIt,
  [LogoIconName.CampaignLogoLT]: assetAyCampaignLogoLt,
  [LogoIconName.CampaignLogoLV]: assetAyCampaignLogoLv,
  [LogoIconName.CampaignLogoPL]: assetAyCampaignLogoPl,
};
